import { render, staticRenderFns } from "./SeminarEntryEntries.vue?vue&type=template&id=981df404&scoped=true"
import script from "./SeminarEntryEntries.vue?vue&type=script&lang=js"
export * from "./SeminarEntryEntries.vue?vue&type=script&lang=js"
import style0 from "./SeminarEntryEntries.vue?vue&type=style&index=0&id=981df404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981df404",
  null
  
)

export default component.exports